"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTypography = exports.StyledSearchBox = exports.StyledResetBox = exports.StyledContainer = exports.StyledCheckboxTree = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _material = require("@mui/material");

var _Typography = require("../Typography");

var _TextButton = _interopRequireDefault(require("../TextButton/TextButton.overrides"));

var _utilities = require("../../utilities");

var StyledContainer = (0, _material.styled)(_material.Box)(function (_ref) {
  var theme = _ref.theme,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth;
  return {
    background: "#fff",
    border: "1px solid ".concat(theme.palette.divider),
    borderRadius: theme.spacing(1),
    maxHeight: "20rem",
    width: fullWidth ? "100%" : "13rem"
  };
});
exports.StyledContainer = StyledContainer;
var StyledCheckboxTree = (0, _material.styled)(_material.Box, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "hideExpand";
  }
})(function (_ref2) {
  var theme = _ref2.theme,
      _ref2$hideExpand = _ref2.hideExpand,
      hideExpand = _ref2$hideExpand === void 0 ? false : _ref2$hideExpand;
  return {
    "& .node-list": {
      "& .rct-collapse": {
        "&:focus": _TextButton.default.MuiButton.root["&.".concat(_utilities.classes.states.MuiFocusVisible)],
        "&:focus:not(:focus-visible)": {
          boxShadow: "none !important"
        },
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)"
        },
        display: hideExpand && "none"
      },
      "& .rct-text": {
        "& .rct-title": {
          fontSize: "0.75rem"
        },
        "& input": {
          "&:focus + .rct-checkbox span": _TextButton.default.MuiButton.root["&.".concat(_utilities.classes.states.MuiFocusVisible)],
          "&:focus:not(:focus-visible) + .rct-checkbox span": {
            boxShadow: "none !important"
          },
          cursor: "pointer",
          display: "initial",
          opacity: 0,
          position: "absolute"
        }
      },
      "& label": {
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
          cursor: "pointer"
        },
        alignItems: "center",
        display: "flex",
        position: "relative",
        width: "100%"
      },
      "& ol": {
        "& .rct-collapse": {
          display: "none"
        },
        "& .rct-text": {
          "& .rct-title": {
            maxWidth: "7rem"
          },
          color: "unset",
          marginBottom: "unset !important"
        },
        paddingLeft: hideExpand ? theme.spacing(3) : "2.2rem"
      },
      "&.rct-node-expanded .rct-text": {
        marginBottom: theme.spacing(1)
      },
      "&:not(:first-of-type)": {
        borderTop: "1px solid ".concat(theme.palette.divider)
      },
      maxHeight: "9rem",
      overflowY: "auto",
      padding: "0.75rem ".concat(theme.spacing(1))
    }
  };
});
exports.StyledCheckboxTree = StyledCheckboxTree;
var StyledSearchBox = (0, _material.styled)(_material.Box)(function (_ref3) {
  var _ref4;

  var theme = _ref3.theme;
  return _ref4 = {}, (0, _defineProperty2.default)(_ref4, "& .".concat(_utilities.classes.components.MuiTextField.root), {
    width: "100%"
  }), (0, _defineProperty2.default)(_ref4, "borderBottom", "1px solid ".concat(theme.palette.divider)), (0, _defineProperty2.default)(_ref4, "padding", "0.75rem"), (0, _defineProperty2.default)(_ref4, "textAlign", "center"), _ref4;
});
exports.StyledSearchBox = StyledSearchBox;
var StyledResetBox = (0, _material.styled)(_material.Box)(function (_ref5) {
  var theme = _ref5.theme;
  return {
    borderTop: "1px solid ".concat(theme.palette.divider),
    padding: "0.75rem"
  };
});
exports.StyledResetBox = StyledResetBox;
var StyledTypography = (0, _material.styled)(_Typography.Typography)(function () {
  return {
    align: "center",
    padding: "0.75rem"
  };
});
exports.StyledTypography = StyledTypography;